import { useEffect, useRef } from 'react'
import { useAppDispatch, useAppSelector } from '@store'
import { getCurrentAdmin, setAuthenticated } from '@store/slices/authSlice'

export const useAuth = () => {
  const dispatch = useAppDispatch()
  const { admin, token, isAuthenticated, loading } = useAppSelector((state) => state.auth)
  const initRef = useRef(false) // 防止重复初始化

  useEffect(() => {
    // 如果已经初始化过，或者loading为false（说明已经处理过），则不再执行
    if (initRef.current || (!loading && isAuthenticated !== undefined)) {
      return
    }

    const initAuth = async () => {
      initRef.current = true // 标记为已初始化
      
      const token = localStorage.getItem('admin_token')
      console.log('useAuth: 初始化认证检查, token存在:', !!token)
      
      if (token) {
        try {
          console.log('useAuth: 尝试验证token...')
          await dispatch(getCurrentAdmin()).unwrap()
          console.log('useAuth: token验证成功')
          dispatch(setAuthenticated(true))
        } catch (error) {
          console.error('useAuth: token验证失败:', error)
          // Token无效，清除本地存储
          localStorage.removeItem('admin_token')
          localStorage.removeItem('admin_refresh_token')
          dispatch(setAuthenticated(false))
        }
      } else {
        console.log('useAuth: 未找到token')
        dispatch(setAuthenticated(false))
      }
    }

    initAuth()
  }, [dispatch, loading, isAuthenticated])

  return {
    admin,
    token,
    isAuthenticated,
    loading,
  }
}



